import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy URL. The product catalogue page was "Manage Menu" in the restaurant
// product and lives at /admin/catalog in retail. Kept as a redirect so
// bookmarks keep working; lib/staff-roles.ts grants both paths.
export const Route = createFileRoute('/admin/menu')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/catalog' })
  },
})
